import { VehicleSuggestion } from "./vehicleSuggestions"

// Tyle wierszy dyspozytor widzi na raz; poniżej tego linia prosta wystarcza do
// kolejności. Limit synchronicznej macierzy HERE to 15, więc 10 zostawia zapas.
export const APPROACH_TOP_N = 10

export type ApproachOrigin = { chatJid: string; lat: number; lon: number }

// Kształt, w którym oba rankingi wracają z PlannerTimelineView: pozycja w
// kolejności + sama sugestia.
export type RankingByChatJid = Map<
  string,
  { index: number; suggestion: VehicleSuggestion }
>

// Czoło rankingu punktowego do doprecyzowania dojazdem drogowym.
//
// Wybieramy WYŁĄCZNIE z pojazdów, które dyspozytor faktycznie widzi: ranking
// liczy się dla całej floty, ale grid jest po filtrze firmy i po wyszukiwaniu.
// Bez przecięcia z widocznym zbiorem cała dziesiątka mogła trafić na pojazdy
// spoza ekranu — widoczne wiersze zostawały na linii prostej na zawsze, a
// żądanie do HERE i tak było wydane.
//
// Kolejność cięcia jest tu istotna: najpierw filtr (widoczność + znana pozycja),
// dopiero potem limit. Odwrotnie limit zjadałby niewidoczne pojazdy i do gps
// jechałoby mniej niż dziesięć origins.
export const selectApproachOrigins = (
  ranking: RankingByChatJid | null,
  visibleChatJids: Set<string>,
  limit: number,
): ApproachOrigin[] => {
  if (!ranking) return []
  return Array.from(ranking.values())
    .sort((left, right) => left.index - right.index)
    .flatMap(({ suggestion }) => {
      const coordinates = suggestion.referenceCoordinates
      // Bez pozycji odniesienia nie ma czego wysłać jako origin.
      if (!coordinates || !visibleChatJids.has(suggestion.chatJid)) return []
      return [
        {
          chatJid: suggestion.chatJid,
          lat: coordinates.lat,
          lon: coordinates.lon,
        },
      ]
    })
    .slice(0, limit)
}
